module.exports = __webpack_public_path__ + "img/HppProductionService.e7e81fd6.png";